<template lang="pug">
    layout

        // Main title
        title-component(
            slot="title"
            type="h2"
            :title="$t('users.create.title')"
        )

        // Login form
        create-form
</template>

<script>
    import Layout from '../../Layout/Layout';
    import CreateForm from './CreateForm';
    import Title from '~components/Title';

    export default {
        components: {
            Layout,
            CreateForm,
            TitleComponent: Title
        }
    };
</script>
